import React from 'react';
import { Spinner } from 'shamrock-clover-ui';
import css from './styles/languageSelectionSpinner.scss';

interface LanguageSelectionSpinnerProps {
  text: string;
}

const LanguageSelectionSpinner: React.FunctionComponent<LanguageSelectionSpinnerProps> = ({ text }) => {
  return (
    <div className={css.loadingContainer}>
      <div className={css.loadingbox}>
        <Spinner color="#0091ea" size="50" />
        <div className={css.loading_text}>{text}</div>
      </div>
    </div>
  );
};

export default LanguageSelectionSpinner;
